import { render } from "./basic.vue?vue&type=template&id=953143c8"
import script from "./basic.vue?vue&type=script&lang=js"
export * from "./basic.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__